export default {
    accept_payments_for_nonclosed_visit: "Tashrif yopiq bo'lmasa, to'lovni qabul qilishga ruxsat bering",
    accountingmonth: "Buxgalteriya oyi",
    accrual: "Hisoblangan summa",
    accruals: "Hisoblangan summa",
    accrued: "Hisoblangan",
    AQSI_account: "AQSI hisob",
    balance_end: "Davr oxiridagi qoldiq",
    balance_start: "Davr boshidagi qoldiq",
    bonus_movement: "Bonus harakati",
    cash_movements: "Pul mablag‘lari harakati",
    cash_received: "Qabul qilingan pul mablag‘lari",
    closed: "Yopiq",
    communal: "Kommunal to‘lovlar",
    deduct_materials_from_doctor_salary: "Shifokor ish haqidan materiallar summasini ushlab qolish",
    deduction: "Ushlab turish",
    deposit_account: "Depozit hisobi",
    deposit_accounts: "Depozit hisoblar",
    deposit_balance: "Depozit qoldig‘i",
    deposit_balance_end: "Davr oxiridagi depozit qoldig‘i",
    deposit_balance_start: "Davr boshidagi depozit qoldig‘i",
    deposit_movement: "Depozit bo‘yicha harakatlar",
    employee: "Xodim",
    employee_id: "Xodim ID",
    expense: "Xarajat",
    first_payment: "Birinchi to‘lov",
    fiscal_cashdesk: "Fiskal kassa",
    for_payment_scan_this_qr_in_kyrgyz_bank: "Toʻlash uchun ushbu QR kodni skanerlang va Qirgʻizistondagi istalgan bankda toʻlang",
    for_payment_scan_this_qr_in_obank_application: "Toʻlash uchun OBank ilovasida ushbu QR-ni skanerlang",
    income: "Daromadlar",
    left_to_pay: "To‘lov uchun qolgan",
    left_to_pay2: "To‘lash uchun qolgan",
    manual_adjustments: "Qo'lda sozlash",
    materials_cost: "Materiallar narxi",
    materials_expense: "Sarflanadigan materiallar",
    open: "Ochish",
    opened: "Ochiq",
    other_expense: "Boshqa xarajatlar",
    other_income: "Boshqa daromadlar",
    pay_out: "To‘lash",
    payment_comment: "To‘lov izohi",
    payment_completed_successfully: "Toʻlov muvaffaqiyatli yakunlandi",
    payment_sum: "To‘lash uchun summa",
    profit: "Daromad",
    recalculate: "Qayta hisoblash",
    refund_to_patient: "Qaytarish",
    rent: "Ijara",
    salaries: "Ish haqi",
    unclosed: "Yopilmagan",
    upselling: "Yuqoriga sotish"
}
